import { render, staticRenderFns } from "./LayoutFull.vue?vue&type=template&id=522baa6f&scoped=true&"
import script from "./LayoutFull.vue?vue&type=script&lang=js&"
export * from "./LayoutFull.vue?vue&type=script&lang=js&"
import style0 from "./LayoutFull.vue?vue&type=style&index=0&id=522baa6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522baa6f",
  null
  
)

export default component.exports